app.directive('modalDialog', ['$ionicModal', '$ionicHistory', 'LocaleService',
    function ($ionicModal, $ionicHistory, LocaleService) {
        return {
            // WARN: at least .5sec delay between showing the modal is needed.
            scope: {
                data: '<',
                onOk: '&onOk',
                onCancel: '&onCancel',
            },
            restrict: 'E',
            link: function (scope, element) {
                $ionicModal.fromTemplateUrl('templates/directives/modalDialog.html', {
                    scope: scope,
                    hardwareBackButtonClose: false,
                    animation: 'slide-in-up'
                }).then(function (modal) {
                    scope.modal = modal;
                });

                LocaleService.wait().then(function (translation) {
                    scope.translation = translation;
                });

                var stateWatch = scope.$watch('data.isOpened', function (newVal, oldVal) {
                    //modal show
                    if (newVal !== oldVal && newVal) {
                        scope.modal.show();
                    }

                    //modal hide
                    if (newVal !== oldVal && !newVal) {
                        // console.log('watch hide');
                        scope.modal.hide();
                    }
                });

                element.on('$destroy', function () {
                    console.log('ELEMENET $destroy');
                    $ionicHistory && $ionicHistory.clearHistory();
                    stateWatch();
                    scope.data = null;
                    scope.modal && scope.modal.remove();
                    scope.modal = null;
                });

                function hideModal() {
                    scope.modal.hide();
                    scope.data.isOpened = false;
                }


                scope.tapCancel = function () {
                    // console.log('executing "cancel" inside modal directive');
                    hideModal();
                    scope.onCancel && scope.onCancel()
                };

                scope.tapOk = function () {
                    // console.log('executing "ok" inside modal directive');
                    hideModal();
                    scope.onOk && scope.onOk()
                };
            }
        }
    }]);
